<template>
  <div class="spa-review">
    <div class="spa-review__header">
      <div class="spa-review__header__author">
        <span class="spa-review__header__author__name"> {{ review.author.name }}, </span>
        <SpaReviewDate
          v-if="false"
          class="spa-review__header__author__date"
          :date="review.date"
        />
      </div>

      <SpaReviewScore :review="review" />
    </div>

    <p class="spa-review__content">
      "{{ review.content }}"
    </p>
  </div>
</template>

<script lang="ts">
import { SpaReview } from '~/core/ts/entity/SpaReview'

import SpaReviewDate from '../atom/SpaReviewDate.atom.vue'
import SpaReviewScore from '../atom/SpaReviewScore.atom.vue'

export default defineNuxtComponent({
  components: {
    SpaReviewDate,
    SpaReviewScore,
  },
  props: {
    review: {
      type: Object as PropType<SpaReview>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.spa-review {
  @apply py-4;
  &__header {
    @apply flex;
    @apply flex-row;
    @apply justify-between;
    @apply w-full;
    @apply py-2;

    &__author {
      @apply flex;
      @apply flex-row;
      @apply flex-wrap;

      &__name,
      &__date {
        @apply text-lg;
      }

      &__name {
        @apply text-spl-primary-dark;
        @apply font-bold;
        @apply mr-1;
      }
    }
  }

  &__content {
    @apply italic;
    @apply py-1;
  }
}
</style>
